module.exports = __webpack_public_path__ + "img/fixlogo.d2f3dd91.png";